import React, { useEffect, useState } from 'react';
import RentalInputsContext from '@app/context/rental/RentalInputsContext';

const tripDistanceMapForHourly = {
  4: '4 hrs / 40 kms',
  8: '8 hrs / 80 kms',
  12: '12 hrs / 120 kms',
};

const Similer = () => {

  const defaultSimilarListings = [
    {
      image: 'https://cdn1.acedms.com/uploads/category/toyota/20210812060959000000-4736858204951330817.jpg.webp',
      title: 'Toyota Camry',
      product_link_filter: '%7B%22toyota%22%3A%5B%22camry%22%5D%7D',
    },
    {
      image: 'https://cdn1.acedms.com/uploads/category/Kia/20220217121354000000-4206558138916532737.png',
      title: 'Kia Seltos',
      product_link_filter: '%7B%22kia%22%3A%5B%22seltos%22%5D%7D',
    },
    {
      image: 'https://cdn1.acedms.com/uploads/category/Mahindra/20221007115410000000-2485321561960040961.jpg.webp',
      title: 'Mahindra XUV300',
      product_link_filter: '%7B%22mahindra%22%3A%5B%22xuv300%22%5D%7D',
    },
    {
      image: 'https://cdn1.acedms.com/uploads/category/Ford/20210824093303000000-7623407206480892929.jpg.webp',
      title: 'Ford Endeavour',
      product_link_filter: '%7B%22ford%22%3A%5B%22endeavour%22%5D%7D',
    },
    {
      image: 'https://cdn1.acedms.com/uploads/category/Skoda/20220128105700000000-2411486984719848961.jpg.webp',
      title: 'Skoda Slavia',
      product_link_filter: '%7B%22skoda%22%3A%5B%22slavia%22%5D%7D',
    },
    {
      image: 'https://cdn1.acedms.com/uploads/category/Renault/20230204065027000000-5988365601627060225.jpg.webp',
      title: 'Renault Kwid',
      product_link_filter: '%7B%22renault%22%3A%5B%22kwid%22%5D%7D',
    },
    {
      image: 'https://cdn1.acedms.com/uploads/category/hummer/20211006051024000000-4742242272192730113.jpg.webp',
      title: 'Hummer H2',
      product_link_filter: '%7B%22hummer%22%3A%5B%22h2%22%5D%7D',
    },
    {
      image: 'https://cdn1.acedms.com/uploads/category/Tata/20231108065847000000-4236966669673936897.jpg.webp',
      title: 'Tata Harrier',
      product_link_filter: '%7B%22tata%22%3A%5B%22harrier%22%5D%7D',
    },
  ];

  const { rentalInputs } = React.useContext(RentalInputsContext);
  const [similarListings, setSimilarListings] = useState(defaultSimilarListings);
  const [product, setProduct] = useState(null);

  const shuffleArray = (array) => {
    return array
      .map(value => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
  };

  const getTripDescription = () => {
    if (rentalInputs?.trip_type === 'one_way') {
      return "Outstation One Way";
    } else if (rentalInputs?.trip_type === 'round_trip') {
      return "Outstation Round Trip";
    } else {
      return `${rentalInputs?.start_city} for ${tripDistanceMapForHourly[rentalInputs?.trip_hours] || rentalInputs?.trip_hours}`;
    }
  };

  const getBookingType = () => {
    if (rentalInputs?.trip_type === 'one_way') {
      return "outstation_one_way";
    } else if (rentalInputs?.trip_type === 'round_trip') {
      return "outstation_roundtrip";
    } else {
      return "hourly";
    }
  };

  // Fetch current product
  const fetchCurrentProduct = async () => {
    try {
      const res = await fetch(`/rentals/get-rental-products?product_title=${encodeURIComponent(rentalInputs?.product_title || '')}`);
      const data = await res.json();
      if (data?.code === 'success' && Array.isArray(data.data) && data.data.length > 0) {
        const currentProduct = data.data[0];
        setProduct(currentProduct);
        // fetchSimilarProducts(currentProduct.vehicle_segment, currentProduct.body_type);
      }
    } catch (err) {
      console.error('Error fetching current product:', err);
    }
  };

  // Fetch similar products
  const fetchSimilarProducts = async (segment, bodyType) => {
    try {
      const params = new URLSearchParams({
        vehicle_segment: segment,
        body_type: bodyType,
      });
      const res = await fetch(`/rentals/get-rental-products?${params.toString()}`);
      const data = await res.json();
      if (data?.code === 'success' && Array.isArray(data.data)) {
        const shuffled = shuffleArray(data.data.filter(p => p.product_title !== rentalInputs?.product_title));
        // setSimilarListings(shuffled.slice(0, 3)); // show only top 3
      }
    } catch (err) {
      console.error('Error fetching similar products:', err);
    }
  };

  const buildExploreUrl = (product_title='') => {
    const bookingType = getBookingType();
    const startDate = rentalInputs?.start_date || '';
    const location = rentalInputs?.start_city || '';
    const rental_to_location = rentalInputs?.end_city;
    const make_model = product_title;
    const rental_end_date = rentalInputs?.trip_type != 'one_way' ? rentalInputs?.end_date : '';
  
    const params = new URLSearchParams({
      booking_type: bookingType,
      rental_start_date: startDate,
      location : location,
      rental_to_location : rental_to_location,
      make_model : make_model,
      rental_end_date : rental_end_date
    });
  
    return `https://droom.in/rental/listings?bucket=car&${params.toString()}`;
  };

  // useEffect(() => {
  //   if (rentalInputs?.product_title) {
  //     fetchCurrentProduct();
  //   }
  // }, [rentalInputs?.product_title]);

  return (
    <>
      {/* {product && ( */}
        <div className="bg-white rounded-lg shadow-sm py-2 px-4">
          <h5 className="charcol-grey">Rent a {rentalInputs?.product_title}</h5>
          <div className="d-flex align-items-center">
            <img
              src={rentalInputs?.photo || product?.photo || ''}
              alt={rentalInputs?.product_title}
              className="mr-2"
              style={{ width: '40%' }}
            />
            <div className="ml-2 mb-1">
              <h6 className="mb-0">{rentalInputs?.product_title}</h6>
              <p className="mb-1">{getTripDescription()}</p>
              <a href={buildExploreUrl()} target="_blank" rel="noopener noreferrer">
                Explore on Droom Rentals
              </a>
            </div>
          </div>
        </div>
      {/* )} */}

      {/* Main Code-------> */}
      {/* {similarListings.length > 0 && (
        <div className="bg-white rounded-lg shadow-sm pt-3 pb-1 px-4 mt-3">
          <h5 className="charcol-grey">Similar Listings on Droom</h5>
          {similarListings.map((item, idx) => (
            <div className="d-flex align-items-center mb-3" key={idx}>
              <img src={item?.photo} alt={item?.product_name_mm} className="mr-2" style={{ height : '25%' ,width: '25%' }}/>
              <div className="ml-2">
                <h6 className="mb-0">{item?.product_name_mm}</h6>
                <p className="mb-1 smiler-text">{`${rentalInputs?.start_city || 'City'} for 4 Hr / 40km`}</p>
                <a className="smilar-links" href={buildExploreUrl(item)} target="_blank" rel="noopener noreferrer">Explore on Droom Rentals</a>
              </div>
            </div>
          ))}
        </div>
      )} */}

      {/* Temporary Fix-------> */}
      {/* Temporary Hardcoded Similar Listings (3 Random) */}
      <div className="bg-white rounded-lg shadow-sm pt-3 pb-1 px-4 mt-3">
        <h5 className="charcol-grey">Similar Listings on Droom</h5>
        {shuffleArray(similarListings).slice(0, 3).map((item, idx) => (
          <div className="d-flex align-items-center mb-3" key={idx}>
            <img
              src={item.image}
              alt={item.title}
              style={{ width: '25%', height: 'auto' }}
              className="mr-2"
            />
            <div className="ml-2">
              <h6 className="mb-0">{item.title}</h6>
              <p className="mb-1 smiler-text">{item.description}</p>
              <a
                className="smilar-links"
                href={buildExploreUrl()}
                target="_blank"
                rel="noopener noreferrer"
              >
                Explore on Droom Rentals
              </a>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Similer;
